/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-non-null-assertion */
/* eslint-disable */
import EditableLabel from '@//components/EditableLabel';
import { useGetProject } from '@/adapters/projects';
import Loading from '@/components/Loading';
import { PROJECTS_URL } from '@/routePaths';
import { OverlayHistoryEntry, VideoFormat } from '@/types/edit';
import ShareIcon from '@mui/icons-material/Share';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import Grid from '@mui/material/Unstable_Grid2';
import { Box } from '@mui/system';
import { ChangeEvent, FC, ReactNode, useContext, useEffect, useMemo, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import styles from './ProjectVideo.module.scss';
// import square from '@/assets/images/square.svg';
// import standard from '@/assets/images/standard.svg';
// import vertical from '@/assets/images/vertical.svg';
import uploadIcon from '@/assets/images/upload.svg';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import { useEditSegment, useProcessTopAndTail } from '@/adapters/edits';
import { useGetIntegrations } from '@/adapters/integrations';
import BrandKitVideoItem from '@/components/BrandKitVideoItem';
import DownloadButton from '@/components/common/DownloadButton';
import { FileUpload } from '@/components/FileUpload';
import Video from '@/components/Video';
import HlsClippedPlayer from '@/components/Video/HlsClippedPlayer';
import VideoActions from '@/components/Video/VideoActions';
import VideoPlayer from '@/components/Video/VideoPlayer';
import { ProjectProvider } from '@/contexts/ProjectContext';
import { UserContext } from '@/contexts/UserContext';
import { VideoProvider } from '@/contexts/VideoContext';
import Clip from '@/entities/clip';
import Edit from '@/entities/edit';
import { UserSubscriptionState } from '@/entities/subscription';
import { useProcessingStatus } from '@/hooks/useProcessingStatus';
import { TranscriptItem } from '@/types/transcript';
import { convertS3PathToHttpUrl } from '@/utils/s3Utils';
import { Checkbox } from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import Api from '../../adapters/api';
import ApiV2 from '../../adapters/api-v2';
import leftSlackIcon from '../../assets/images/left-slack.svg';

interface Props {
  refetchInterval?: number;
  initialActiveFontFamily?: string;
}

const ProjectVideo: FC<Props> = ({ refetchInterval, initialActiveFontFamily }) => {
  const { projectId, videoId = 'original' } = useParams<{ projectId: string; videoId: string }>();
  const { userState } = useContext(UserContext);
  const [addBg, setAddBg] = useState<boolean>(false);
  const { data: project, refetch: reloadProject, isLoading } = useGetProject(projectId!);
  const { data: integrations = [], refetch } = useGetIntegrations();
  const navigate = useNavigate();

  // Get the current edit to check processing status
  const currentEdit = project?.edits.find((edit) => edit.id === videoId);
  // Prefer `fullPath` over `pathKey`: the deprecated public-web-api Lambda
  // builds `pathKey` as `seg.overlay?.path || seg.path` *without* gating on
  // overlay.status, so any failed overlay leaves pathKey pointing to a 404
  // forever. `fullPath` is built with an explicit
  // `seg.overlay?.status === PROCESSED` gate, so it falls back to the
  // segment's original path when the overlay didn't actually render.
  // Falls back to pathKey for legacy responses that lack fullPath.
  const pollUrl = currentEdit?.fullPath ?? currentEdit?.pathKey;
  const {
    isProcessed,
    hasFailed: processingFailed,
    error: processingError,
  } = useProcessingStatus(pollUrl, !!pollUrl, {
    hasFailed: currentEdit?.status === 'Failed',
  });

  const { mutateAsync: processTopAndTail } = useProcessTopAndTail(projectId!);
  const [platforms, setPlatforms] = useState<{
    wowza: boolean;
    jwp: boolean;
    drive: boolean;
  }>({
    wowza: false,
    jwp: false,
    drive: false,
  });
  const { mutateAsync: editSegment } = useEditSegment(projectId!);
  const [segmentId, setSegmentId] = useState<string | null>(null);
  const [videoSize] = useState<string>('16:9');
  const [selectedFormat, setSelectedFormat] = useState<VideoFormat>('original');
  const [selectedColor, setSelectedColor] = useState<string | null>(null);
  const [selectedBackgroundColor, setSelectedBackgroundColor] = useState<string>('');
  const [isBold, setIsBold] = useState<boolean>(false);
  const [isItalic, setIsItalic] = useState<boolean>(false);
  const [headingTitle, setHeadingTitle] = useState<string>('');
  const [activeFontFamily, setActiveFontFamily] = useState<string | null>(null);
  const fontsizeArray: number[] = Array.from({ length: 17 }, (_, index) => index * 2 + 8);
  const [selectedFontSize, setSelectedFontSize] = useState<number>(12);
  const [logoPosition, setLogoPosition] = useState<string>('top-right');
  const [selectedImage, setSelectedImage] = useState<Blob>(new Blob());
  const [textInputFocus, setTextInputFocus] = useState<boolean>(false);
  const [textAlignment, setTextAlignment] = useState<string>('center');
  const [state, setState] = useState<UserSubscriptionState[]>([]);
  const [addLogo, setAddLogo] = useState<boolean | null>(null);
  const [addIntro, setAddIntro] = useState<boolean | null>(null);
  const [addOutro, setAddOutro] = useState<boolean | null>(null);
  const [transcriptLoading, setTranscriptLoading] = useState<boolean>(false);
  const [transcript, setTranscript] = useState<TranscriptItem[]>([]);
  const [isProcessing, setIsProcessing] = useState<boolean>(false);
  const [processingProgress, setProcessingProgress] = useState<string>('');
  const [processingSegmentId, setProcessingSegmentId] = useState<string | null>(null);
  const [isFormatVideoLoading, setIsFormatVideoLoading] = useState<boolean>(false);
  const [formatVideoError, setFormatVideoError] = useState<string | null>(null);
  const [copiedOverlayTimestamp, setCopiedOverlayTimestamp] = useState<number | null>(null);

  useEffect(() => {
    if (userState) {
      setState(
        userState.SubscriptionState.filter(
          (sub) =>
            sub.plan === process.env.REACT_APP_STRIPE_PLAN_PRO_ANNUAL ||
            sub.plan === process.env.REACT_APP_STRIPE_PLAN_PRO_MONTH ||
            sub.plan === process.env.REACT_APP_STRIPE_RTMP_PLAN_MONTHLY ||
            sub.plan === process.env.REACT_APP_STRIPE_RTMP_PLAN_ANNUAL,
        ),
      );
    }
  }, [userState]);

  // Build a sanitized stream URL from project.streamPath (strip query/hash)
  const sanitizedStreamUrl = useMemo(() => {
    try {
      const raw = project?.streamPath as string | undefined;
      if (!raw) return '';
      const u = new URL(raw);
      return `${u.origin}${u.pathname}`;
    } catch (e) {
      return (project?.streamPath as string | undefined)?.split('?')[0] ?? '';
    }
  }, [project?.streamPath]);

  // Get the video URL to use - processed video if available, otherwise original stream
  const videoUrlToUse = useMemo(() => {
    if (isProcessed && currentEdit) {
      try {
        // Select URL based on selected format
        // Note: pathPortrait and pathSquare are already signed HTTPS URLs from backend
        // Only pathKey needs conversion from S3 path

        if (selectedFormat === 'portrait' && currentEdit.pathPortrait) {
          return currentEdit.pathPortrait; // Already a signed URL
        } else if (selectedFormat === 'square' && currentEdit.pathSquare) {
          return currentEdit.pathSquare; // Already a signed URL
        } else if (currentEdit.fullPath) {
          // fullPath is a signed URL chosen by the API based on overlay
          // status; prefer it over pathKey, which is unreliable for
          // segments that ever had a failed overlay request.
          return currentEdit.fullPath;
        } else if (currentEdit.pathKey) {
          return convertS3PathToHttpUrl(currentEdit.pathKey);
        }
      } catch (e) {
        console.warn('Failed to convert pathKey to URL:', e);
        return sanitizedStreamUrl;
      }
    }
    return sanitizedStreamUrl;
  }, [isProcessed, currentEdit, selectedFormat, sanitizedStreamUrl]);

  // Poll for video availability when format changes
  useEffect(() => {
    if (!currentEdit || selectedFormat === 'original') {
      setIsFormatVideoLoading(false);
      setFormatVideoError(null);
      return;
    }

    let isCancelled = false;

    const checkVideoAvailability = async () => {
      const pathKey =
        selectedFormat === 'portrait' ? currentEdit.pathPortrait : currentEdit.pathSquare;

      // If no path, show error immediately (path should exist from creation)
      if (!pathKey) {
        setIsFormatVideoLoading(false);
        setFormatVideoError(`${selectedFormat} format not available`);
        return;
      }

      // Path exists, now check if video file is available
      setIsFormatVideoLoading(true);
      setFormatVideoError(null);

      try {
        // pathKey is already a signed HTTPS URL from backend
        const videoUrl = pathKey;

        // Try to fetch the video with Range header to see if it exists
        const checkVideo = async (retries = 60): Promise<boolean> => {
          for (let i = 0; i < retries; i++) {
            if (isCancelled) return false;

            try {
              // Use GET with Range: bytes=0-0 to check if video is ready
              const response = await fetch(videoUrl, {
                method: 'GET',
                headers: {
                  Range: 'bytes=0-0',
                },
              });
              if (response.ok || response.status === 206) {
                return true;
              }
            } catch (error) {
              console.log(`Attempt ${i + 1}/${retries}: Video not ready yet`);
            }
            // Wait 5 seconds before next retry
            await new Promise((resolve) => setTimeout(resolve, 5000));
          }
          return false;
        };

        const isAvailable = await checkVideo();

        if (!isCancelled) {
          if (isAvailable) {
            setIsFormatVideoLoading(false);
            setFormatVideoError(null);
          } else {
            setIsFormatVideoLoading(false);
            setFormatVideoError(
              `${selectedFormat} format video is still processing. Please try again later.`,
            );
          }
        }
      } catch (error) {
        if (!isCancelled) {
          console.error('Error checking video availability:', error);
          setIsFormatVideoLoading(false);
          setFormatVideoError(`Error loading ${selectedFormat} format video`);
        }
      }
    };

    void checkVideoAvailability();

    // Cleanup function
    return () => {
      isCancelled = true;
    };
  }, [selectedFormat, currentEdit]);

  // const handleVideoSizeChange = (event: SelectChangeEvent): void => {
  //   setSelectedVideoSize(event.target.value);
  // };

  const handleColorChange = (event: SelectChangeEvent): void => {
    setSelectedColor(event.target.value);
  };

  const handleTextFieldChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    setSelectedColor(event.target.value);
  };

  const handleBackgroundColorChange = (event: SelectChangeEvent): void => {
    setSelectedBackgroundColor(event.target.value);
  };

  const handleBackgroundColorTextFieldChange = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    setSelectedBackgroundColor(event.target.value);
  };

  const handleToggleBold = (): void => {
    setIsBold(!isBold);
  };

  const handleToggleItalic = (): void => {
    setIsItalic(!isItalic);
  };

  const handleFontSizeChange = (event: SelectChangeEvent<string>): void => {
    const value = parseInt(event.target.value, 10);
    setSelectedFontSize(value);
  };

  const handleLogoPosition = (event: SelectChangeEvent): void => {
    setLogoPosition(event.target.value);
  };

  useEffect(() => {
    const wowzaExists = integrations.some((integration: any) => integration.platform['wowza']);
    const jwpExists = integrations.some((integration: any) => integration.platform['jwp']);
    const driveExists = integrations.some((integration: any) => integration.platform['drive']);

    setPlatforms({ wowza: wowzaExists, jwp: jwpExists, drive: driveExists });
  }, [integrations]);

  const handleAddBg = (event: ChangeEvent<HTMLInputElement>): void => {
    // event.preventDefault();
    // event.stopPropagation();
    if (event.target.checked === false) {
      setSelectedBackgroundColor('transparent');
    }
    setAddBg(event.target.checked);
  };

  const handleAddLogo = (event: ChangeEvent<HTMLInputElement>): void => {
    setAddLogo(event.target.checked);
  };

  const handleAddIntro = (event: ChangeEvent<HTMLInputElement>): void => {
    setAddIntro(event.target.checked);
  };

  const handleAddOutro = (event: ChangeEvent<HTMLInputElement>): void => {
    setAddOutro(event.target.checked);
  };

  const handleClickPaidFeature = (): void => {
    // Subscription page removed - no redirect to subscription/plans
    // if (state.length === 0 && userState && userState.trialDays === 0) {
    //   navigate('/subscription/plans');
    // }
  };

  useEffect(() => {
    const editProject = project?.edits.find((el) => el.id === videoId);
    if (editProject && addLogo === null && addIntro === null && addOutro === null) {
      setAddLogo(editProject?.overlaySettings?.enableLogo ?? false);
      setAddIntro(editProject?.overlaySettings?.enableIntro ?? false);
      setAddOutro(editProject?.overlaySettings?.enableOutro ?? false);
    }
  }, [videoId, project]);

  let videoComponent: ReactNode;
  let video: Clip | undefined | null = null;
  let edit: Edit | undefined | null = null;

  const headingStyle = useMemo<React.CSSProperties>(() => {
    let color: any = 'black';
    if (project) {
      color =
        project.edits.find((edit) => edit.id === videoId) &&
        project.edits.find((edit) => edit.id === videoId)?.overlaySettings &&
        project.edits.find((edit) => edit.id === videoId)?.overlaySettings.color
          ? project.edits.find((edit) => edit.id === videoId)?.overlaySettings.color
          : 'black';
    }
    return {
      color: selectedColor ?? color,
      backgroundColor: selectedBackgroundColor,
      fontWeight: isBold ? 'bold' : 'normal',
      fontStyle: isItalic ? 'italic' : 'normal',
      fontFamily: activeFontFamily ?? undefined,
      fontSize: `${selectedFontSize}px`,
      paddingLeft: '5px',
      paddingRight: '5px',
      paddingTop: '5px',
      paddingBottom: '5px',
    } as React.CSSProperties;
  }, [
    project,
    selectedColor,
    selectedBackgroundColor,
    isBold,
    isItalic,
    activeFontFamily,
    selectedFontSize,
  ]);

  const headingContainerStyle = useMemo<React.CSSProperties>(() => {
    return {
      display: 'flex',
      justifyContent:
        textAlignment === 'left' ? 'flex-start' : textAlignment === 'right' ? 'flex-end' : 'center',
      width: '100%',
      position: 'absolute',
      top: 50,
    } as React.CSSProperties;
  }, [
    project,
    selectedColor,
    selectedBackgroundColor,
    isBold,
    isItalic,
    activeFontFamily,
    selectedFontSize,
    textAlignment,
  ]);
  const imageAtr = useMemo(() => {
    const position: { [key: string]: any } = {
      position: 'absolute',
      objectFit: 'contain',
      height: '10%',
      zIndex: 1,
    };
    if (logoPosition === 'top-right') {
      position['top'] = 10;
      position['right'] = 10;
    } else if (logoPosition === 'top-left') {
      position['top'] = 10;
      position['left'] = 10;
    } else if (logoPosition === 'bottom-left') {
      position['bottom'] = 10;
      position['left'] = 10;
    } else if (logoPosition === 'bottom-right') {
      position['bottom'] = 10;
      position['right'] = 10;
    }
    return {
      image: selectedImage,
      position: position,
    };
  }, [selectedImage, logoPosition, videoSize]);

  /**
   * Start polling S3 for video processing progress updates
   * @param segId - The segment ID to track progress for
   * @reason Provides real-time progress updates to the user during video processing
   */
  const startProgressPolling = (segId: string) => {
    let isPastComplete = true;
    const pollInterval = setInterval(async () => {
      try {
        // Use the same bucket as the project's stream path
        // Extract bucket from project.streamPath if available
        let bucket = 'your-default-bucket';
        if (project?.streamPath) {
          try {
            const streamUrl = new URL(project.streamPath);
            // Extract bucket from S3 URL pattern: https://bucket.s3.amazonaws.com/...
            // or https://eos-projects-test.s3-accelerate.amazonaws.com/
            const hostParts = streamUrl.hostname.split('.');
            if (
              hostParts.length >= 3 &&
              (hostParts[1] === 's3' || hostParts[1].startsWith('s3-'))
            ) {
              bucket = hostParts[0];
            }
          } catch (e) {
            console.warn('Could not extract bucket from streamPath:', e);
          }
        }

        const progressUrl = `https://${bucket}.s3.amazonaws.com/progress/${projectId}/${segId}/progress.html`;
        const response = await fetch(progressUrl);

        if (response.ok) {
          const htmlContent = await response.text();

          // Check if processing is complete by looking for completed class in HTML
          if (!htmlContent.includes('class="completed"')) {
            isPastComplete = false;
            // Directly insert HTML content
            setProcessingProgress(htmlContent);
          } else if (!isPastComplete) {
            // Processing is complete
            setIsProcessing(false);
            clearInterval(pollInterval);

            // Refresh project data to show new status
            void reloadProject();
            // Directly insert HTML content
            setProcessingProgress(htmlContent);
          }
        } else if (response.status === 404) {
          // Progress file doesn't exist yet, this is expected initially
          // Keep the current progress message
        } else {
          // Other error status codes
          console.warn('Failed to fetch progress:', response.status, response.statusText);
        }
      } catch (error) {
        console.error('Error polling progress:', error);
      }
    }, 3000); // Poll every 3 seconds

    // Clean up polling after 10 minutes (timeout)
    setTimeout(() => {
      clearInterval(pollInterval);
      if (isProcessing) {
        setIsProcessing(false);
        setProcessingProgress('Processing timeout - please refresh the page');
      }
    }, 600000); // 10 minutes
  };

  const handleSave = async () => {
    const logoPath: any = project && project.edits.find((edit) => edit.id === videoId);
    const overlaySettings: any =
      project &&
      project.edits.find((edit) => edit.id === videoId) &&
      project.edits.find((edit) => edit.id === videoId)?.overlaySettings;
    const spiltedPath = window.location.pathname.split('/');
    const segId = segmentId ?? spiltedPath[3];
    const temp = project?.edits.filter((edit) => edit.id === spiltedPath[3]);
    const data = {
      name: spiltedPath[3],
      selectedFormat: selectedFormat,
      overlay: {
        startTimestamp: `${temp?.[0]?.timing?.start}`,
        endTimestamp: `${temp?.[0]?.timing?.end}`,
      },
      overlaySettings: {
        ...(headingTitle && {
          title: headingTitle,
        }),
        color: selectedColor
          ? selectedColor
          : overlaySettings && overlaySettings.color
          ? overlaySettings.color
          : 'black',
        ...(addBg && {
          backgroud: selectedBackgroundColor
            ? selectedBackgroundColor
            : overlaySettings && overlaySettings.backgroud
            ? overlaySettings.backroud
            : '',
        }),
        fontSize: selectedFontSize ? `${selectedFontSize}` : '24',
        font: activeFontFamily
          ? activeFontFamily
          : overlaySettings && overlaySettings.font
          ? overlaySettings.font
          : 'Roboto',
        justified:
          textAlignment === 'center'
            ? 'top center'
            : textAlignment === 'left'
            ? 'top left'
            : 'top-right',
        enableLogo: addLogo,
        enableIntro: addIntro,
        enableOutro: addOutro,
        ...(addLogo && {
          logoPosition: logoPosition,
        }),
        ...(addLogo &&
          logoPath?.overlaySettings?.logo && {
            logo: logoPath?.overlaySettings?.logo,
          }),
        ...(addIntro &&
          logoPath?.overlaySettings?.intro && {
            intro: logoPath?.overlaySettings?.intro,
          }),
        ...(addOutro &&
          logoPath?.overlaySettings?.outro && {
            outro: logoPath?.overlaySettings?.outro,
          }),
      },
    };

    try {
      setIsProcessing(true);
      setProcessingProgress('Submitting video processing request...');
      setProcessingSegmentId(segId);

      const response = await ApiV2.patch(
        `/api/projects/${projectId}/segments/${segId}/overlay`,
        data,
      );

      setProcessingProgress('Processing started. Please wait...');

      // Start polling for progress
      startProgressPolling(segId);
    } catch (error) {
      console.error('Failed to save changes:', error);
      setIsProcessing(false);
      setProcessingProgress('');
      setProcessingSegmentId(null);
    }
  };

  /**
   * Uploads segment asset (intro/outro/logo) directly to S3 using pre-signed URL
   * Reason: Bypasses API Gateway's 10MB limit for large video files
   */
  const uploadImage = async (file: File, type: string) => {
    const spiltedPath = window.location.pathname.split('/');
    const segId = segmentId ?? spiltedPath[3];

    // Step 1: Get pre-signed URL from backend
    const response = (await Api.post(
      `projects/${projectId}/segments/${segId}/asset/upload-url/${type}`,
      {
        fileName: file.name,
      },
    )) as unknown as { url: string; s3Path: string };

    // Step 2: Upload directly to S3 using the pre-signed URL
    const uploadResponse = await fetch(response.url, {
      method: 'PUT',
      body: file,
      headers: {
        'Content-Type': file.type,
      },
    });

    if (!uploadResponse.ok) {
      throw new Error(`Upload failed: ${uploadResponse.statusText}`);
    }

    // Refresh to show the uploaded asset
    !segmentId
      ? void reloadProject()
      : (window.location.pathname = `/projects/1702545844954/${segmentId}`);
  };

  const handleGenerateTranscript = async () => {
    navigate(`/projects/${projectId}/transcript/${videoId}`);
  };

  /**
   * Copies the overlay URL to the clipboard
   * @reason Allows users to easily share overlay videos with others
   */
  const shareOverlay = async (overlayUrl: string, timestamp: number) => {
    try {
      await navigator.clipboard.writeText(overlayUrl);
      setCopiedOverlayTimestamp(timestamp);
      // Reset the copied state after 2 seconds
      setTimeout(() => {
        setCopiedOverlayTimestamp(null);
      }, 2000);
    } catch (error) {
      console.error('Failed to copy overlay URL:', error);
    }
  };

  /**
   * Creates a deterministic filename for overlay downloads
   * @reason Ensures overlay downloads get a stable name when Content-Disposition is respected
   */
  const getOverlayFileName = (overlay: OverlayHistoryEntry): string => {
    const baseName =
      currentEdit?.name || project?.name || `overlay-${overlay.timestamp.toString()}`;
    const safeBaseName = baseName.replace(/[^a-zA-Z0-9-_]+/g, '-');
    const formatSuffix = overlay.format ? `-${overlay.format}` : '';
    return `${safeBaseName}${formatSuffix}-${overlay.timestamp}.mp4`;
  };

  const loadingComponent = (
    <div className={styles.box}>
      <Loading text="Your video will be ready shortly..." />
    </div>
  );

  if (!project || !project.original) {
    videoComponent = <></>;
  } else {
    if (videoId === 'original') {
      video = project.original;
      const topAndTailEdit = project.edits.find((e) => e.id === 'top-and-tail');
      videoComponent = project.original.fullPath ? (
        <div className={styles.box}>
          <Video
            url={project.original.fullPath}
            timing={topAndTailEdit?.timing}
            onConfirm={processTopAndTail}
            setTextForInput={() => Promise.resolve()}
            data-testid={`video-edit-1`}
            editable
          >
            <VideoPlayer />
            <VideoActions
              platforms={platforms}
              saveChanges={() => handleSave()}
              onGenerateTranscript={handleGenerateTranscript}
              status={isProcessing}
            />
          </Video>
        </div>
      ) : null;
    } else {
      video = project.edits.find((edit) => edit.id === videoId);
      if (video) {
        edit = video as Edit;
        videoComponent = (
          <div className={styles.box}>
            <div className={styles.boxHeader}>
              {/* <h4>{edit.name}</h4> */}
              <EditableLabel
                text={edit.name}
                onSave={async (text) => {
                  {
                    await editSegment({
                      name: text,
                      segmentId: segmentId ? segmentId : edit?.id,
                    });

                    setSegmentId(text.replaceAll(' ', '-'));
                    // window.location.replace(
                    //   window.location.pathname.replace(
                    //     window.location.pathname
                    //       .split('/')
                    //       [window.location.pathname.split('/').length - 1].replaceAll(' ', '-'),
                    //     text,
                    //   ),
                    // );
                  }
                }}
              />
            </div>
            <Video
              inputFocus={textInputFocus}
              setTextForInput={() => {
                setHeadingTitle((prevKey) => prevKey + ' ');
                // setHeadingTitle(headingTitle + ' ')
              }}
              url={videoUrlToUse}
              onConfirm={() => Promise.resolve()}
            >
              {/* Format selector tabs */}
              {currentEdit && (
                <Box
                  className={styles.resizingDropDown}
                  sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}
                  data-voice-format-container
                >
                  <p className={styles.projectsFunctionHeading}>
                    <strong>Reframing</strong>
                  </p>
                  <Tabs
                    value={selectedFormat}
                    onChange={(_, newValue) => setSelectedFormat(newValue as VideoFormat)}
                    aria-label="video format selector"
                  >
                    <Tab label="Original (16:9)" value="original" data-voice-format="original" />
                    <Tab label="Portrait (9:16)" value="portrait" data-voice-format="portrait" />
                    <Tab label="Square (1:1)" value="square" data-voice-format="square" />
                  </Tabs>
                </Box>
              )}
              {/* Loading indicator for format video */}
              {isFormatVideoLoading && (
                <Box sx={{ p: 2, bgcolor: '#f5f5f5', borderRadius: 1, mb: 2 }}>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <CircularProgress size={20} sx={{ marginRight: 1 }} />
                    <span>
                      Loading {selectedFormat} format video... This may take a few minutes.
                    </span>
                  </div>
                </Box>
              )}
              {/* Error message for format video */}
              {formatVideoError && !isFormatVideoLoading && (
                <Box sx={{ p: 2, bgcolor: '#fff3cd', borderRadius: 1, mb: 2, color: '#856404' }}>
                  {formatVideoError}
                </Box>
              )}
              {/* <div
                style={{ width: '100%', height: 250, backgroundColor: 'black', flexWrap: 'wrap' }}
              > */}
              <HlsClippedPlayer
                start={isProcessed && currentEdit?.pathKey ? undefined : edit?.timing?.start}
                end={isProcessed && currentEdit?.pathKey ? undefined : edit?.timing?.end}
                headingTitle={headingTitle}
                headingStyle={headingStyle}
                headingContainerStyle={headingContainerStyle}
                imageAtr={imageAtr}
                addLogo={Boolean(addLogo)}
                logo={
                  !isProcessed
                    ? project.edits.find((edit) => edit.id === videoId)?.overlaySettings?.logoPath
                    : selectedImage.size !== 0
                    ? URL.createObjectURL(selectedImage)
                    : project.edits.find((edit) => edit.id === videoId)?.overlaySettings?.logoPath
                }
              />
              {/* </div> */}
              <VideoActions
                status={isProcessing || !isProcessed}
                platforms={platforms}
                saveChanges={() => handleSave()}
                onGenerateTranscript={handleGenerateTranscript}
              />
              {processingFailed && (
                <div
                  style={{
                    padding: '10px',
                    backgroundColor: '#fdecea',
                    color: '#611a15',
                    border: '1px solid #f5c2c0',
                    borderRadius: '5px',
                    margin: '10px 0',
                  }}
                >
                  Processing failed{processingError ? `: ${processingError}` : ''}. The video task
                  was not started. Please try again or contact support.
                </div>
              )}
              {processingProgress &&
                (processingProgress.includes('<') ? (
                  <div dangerouslySetInnerHTML={{ __html: processingProgress }} />
                ) : (
                  <div
                    style={{
                      padding: '10px',
                      backgroundColor: '#f0f0f0',
                      borderRadius: '5px',
                      margin: '10px 0',
                    }}
                  >
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {isProcessing && <CircularProgress size={20} sx={{ marginRight: 1 }} />}
                      <span>{processingProgress}</span>
                    </div>
                  </div>
                ))}
              <div className={currentEdit?.pathKey && !isProcessed ? styles.disabledAll : ''}>
                {/* <VideoTimelineControl
                  //@ts-ignore
                  introLink={video?.overlaySettings?.intro}
                  //@ts-ignore
                  outroLink={video?.overlaySettings?.outro}
                  uploadAssetMethod={uploadImage}
                /> */}
              </div>
            </Video>
          </div>
        );
      }
    }
  }

  return (
    <>
      {isLoading || !project || !videoComponent ? (
        loadingComponent
      ) : (
        <ProjectProvider project={project}>
          <div className={styles.projectDetailInner}>
            <div className={styles.routePaths}>
              <div>
                <Link to={PROJECTS_URL} className={`${styles.burgerContentItem} projects`}>
                  Projects
                </Link>
              </div>
              <div className={styles.leftSlack}>
                <img src={leftSlackIcon} alt="left" />
              </div>
              <div className={styles.currentProjectName}>{project.name}</div>
            </div>
            <div className={styles.projectDetailHeader}>
              <div>
                {/* <div className={styles.projectNameInputWrapper}>
                  <EditableLabel
                    text={project.name}
                    onSave={(text) => editProject({ name: text })}
                    testId="project-name"
                  />
                </div> */}
              </div>
            </div>

            <Box sx={{ maxWidth: '100%' }}>
              <Grid container flexDirection={{ xs: 'column-reverse', md: 'row' }}>
                <Grid
                  xs={12}
                  sm={12}
                  md={6}
                  lg={6}
                  xl={6}
                  sx={{
                    opacity:
                      (userState && state.length === 0 && userState.trialDays === 0) ||
                      (currentEdit?.pathKey && !isProcessed)
                        ? '0.4'
                        : '10',
                    pointerEvents:
                      userState && state.length === 0 && userState.trialDays === 0
                        ? 'unset'
                        : currentEdit?.pathKey && !isProcessed
                        ? 'none'
                        : 'unset',
                  }}
                >
                  <h2 className={styles.projectsSectionHeading}>Video Settings</h2>
                  {/* Resize Clip */}
                  {/* <div>
                    <h3 className={styles.projectsFunctionHeading}>Resize Clip:</h3>
                    <FormControl className={styles.resizingDropDown}>
                      <Select
                        value={videoSize}
                        onChange={handleVideoSizeChange}
                        displayEmpty
                        className={styles.resizingOptions}
                      >
                        <MenuItem value={'16:9'}>
                          <div className={styles.resizingOption}>
                            <img src={standard} alt="standard" />
                            <strong>Standard</strong>
                            <p>(16:9)</p>
                          </div>
                        </MenuItem>
                        <MenuItem value={'9:16'}>
                          <div className={styles.resizingOption}>
                            <img src={vertical} alt="vertical" />
                            <strong>Vertical</strong>
                            <p>(9:16)</p>
                          </div>
                        </MenuItem>
                        <MenuItem value={'1:1'}>
                          <div className={styles.resizingOption}>
                            <img src={square} alt="square" />
                            <strong>Square</strong>
                            <p>(1:1)</p>
                          </div>
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div> */}
                  {/* Title */}
                  {/* <Box className={styles.resizingDropDown} ref={boxRef1}>
                    <h3 className={styles.projectsFunctionHeading}>Title:</h3>
                    <TextField
                      id="outlined-basic"
                      label="Headline Title"
                      variant="outlined"
                      multiline
                      rows={2}
                      onBlur={(e) => {
                        setTextInputFocus(false);
                      }}
                      onFocusCapture={(e) => {
                        setTextInputFocus(true);
                      }}
                      onChange={(e) => {
                        setHeadingTitle(e.target.value);
                      }}
                      sx={{ width: '100%' }}
                      InputProps={{
                        style: {
                          fontWeight: isBold ? 'bold' : 'normal',
                          fontStyle: isItalic ? 'italic' : 'normal',
                          fontFamily: activeFontFamily
                            ? activeFontFamily
                            : project.edits.find(
                                (edit) => edit.id === videoId,
                              )?.overlaySettings.font
                            ? project.edits.find(
                                (edit) => edit.id === videoId,
                              )?.overlaySettings.font
                            : 'Roboto',
                          fontSize: `${selectedFontSize}px`,
                        },
                      }}
                    />
                  </Box> */}
                  {/* Title Style Elements */}
                  {/* <Box className={styles.resizingDropDown} ref={boxRef2}>
                    <h3 className={styles.projectsFunctionHeading}>Title Style Elements:</h3>
                    <List sx={{ border: '1px solid #a7a7a7', borderRadius: '5px' }}>
                      Font
                      <ListItem sx={{ justifyContent: 'space-between' }}>
                        <div>
                          <p className={styles.projectsFunctionHeading}>
                            <strong>Font</strong>
                          </p>
                        </div>
                        <div className={styles.fontStyling}>
                          <FontPicker
                            families={[
                              'Arimo',
                              'Barlow',
                              'DM Sans',
                              'Dosis',
                              'IBM Plex Sans',
                              'Inconsolata',
                              'Inter',
                              'Kanit',
                              'Karla',
                              'Lora',
                              'Noto Sans',
                              'Open Sans',
                              'Poppins',
                              'PT Sans',
                              'Raleway',
                              'Roboto',
                              'Titillium Web',
                            ]}
                            apiKey="AIzaSyCbKCvln87bV6cUuP87TG2hm6-sL4SF-d8"
                            activeFontFamily={
                              activeFontFamily
                                ? activeFontFamily
                                : project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings.font
                                ? project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings.font
                                : 'Roboto'
                            }
                            onChange={(nextFont) => setActiveFontFamily(nextFont.family)}
                          />
                          <Select
                            value={selectedFontSize.toString()}
                            onChange={handleFontSizeChange}
                            sx={{ height: '35px', alignItems: 'center' }}
                          >
                            {fontsizeArray.map((size) => (
                              <MenuItem key={size} value={size.toString()}>
                                {size}
                              </MenuItem>
                            ))}
                          </Select>
                        </div>
                      </ListItem>
                      Colour
                      <ListItem sx={{ justifyContent: 'space-between' }}>
                        <div>
                          <p className={styles.projectsFunctionHeading}>
                            <strong>Color</strong>
                          </p>
                        </div>
                        <div>
                          <input
                            type="color"
                            id="colorpicker"
                            style={{
                              border: 'none',
                              background: 'none',
                              width: '25px',
                              height: '25px',
                            }}
                            value={
                              selectedColor
                                ? selectedColor
                                : project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings?.color
                                ? project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings?.color
                                : 'black'
                            }
                            onChange={handleColorChange}
                          />
                          <TextField
                            id="standard-basic"
                            variant="standard"
                            sx={{ width: '100px', padding: '0 10px' }}
                            value={
                              selectedColor
                                ? selectedColor
                                : project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings?.color
                                ? project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings?.color
                                : 'black'
                            }
                            onChange={handleTextFieldChange}
                          />
                          <img src={colorIcon} alt="color-picker" />
                        </div>
                      </ListItem>
                      Background Color
                      <ListItem sx={{ justifyContent: 'space-between' }}>
                        <div>
                          <p className={styles.projectsFunctionHeading}>
                            <strong>Add Backgroud Color?</strong>
                          </p>
                        </div>
                        <Checkbox defaultChecked={addBg} color="default" onChange={handleAddBg} />
                      </ListItem>
                      {addBg && (
                        <ListItem sx={{ justifyContent: 'space-between' }}>
                          <div>
                            <p className={styles.projectsFunctionHeading}>
                              <strong>Background Color</strong>
                            </p>
                          </div>
                          <div>
                            <input
                              type="color"
                              id="colorpicker"
                              style={{
                                border: 'none',
                                background: 'none',
                                width: '25px',
                                height: '25px',
                              }}
                              value={selectedBackgroundColor}
                              onChange={handleBackgroundColorChange}
                            />
                            <TextField
                              id="standard-basic"
                              variant="standard"
                              sx={{ width: '100px', padding: '0 10px' }}
                              value={selectedBackgroundColor}
                              onChange={handleBackgroundColorTextFieldChange}
                            />
                            <img src={colorIcon} alt="color-picker" />
                          </div>
                        </ListItem>
                      )}
                      Text Formatting
                      <ListItem>
                        <div className={styles.textFormatting}>
                          <div className={styles.fontStyling}>
                            {[
                              'Dosis',
                              'Inconsolata',
                              'Inter',
                              'Poppins',
                              'Arimo',
                              'Barlow',
                              'DM Sans',
                              'IBM Plex Sans',
                              'Kanit',
                              'Karla',
                              'Lora',
                              'Noto Sans',
                              'Open Sans',
                              'PT Sans',
                              'Raleway',
                              'Titillium Web',
                              'Roboto',
                            ].includes(
                              // @ts-ignore
                              activeFontFamily
                                ? activeFontFamily
                                : project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings &&
                                  project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings?.font
                                ? project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings?.font
                                : 'Roboto',
                            ) && (
                              <img
                                src={boldIcon}
                                alt="bold"
                                className={styles.stylingFontIcons}
                                style={{
                                  width: '20px',
                                  height: '20px',
                                  backgroundColor: isBold ? '#e0e0e0' : 'transparent',
                                }}
                                onClick={handleToggleBold}
                              />
                            )}
                            {[
                              'Poppins',
                              'Arimo',
                              'Barlow',
                              'DM Sans',
                              'IBM Plex Sans',
                              'Kanit',
                              'Karla',
                              'Lora',
                              'Noto Sans',
                              'Open Sans',
                              'PT Sans',
                              'Raleway',
                              'Titillium Web',
                              'Roboto',
                            ].includes(
                              // @ts-ignore
                              activeFontFamily
                                ? activeFontFamily
                                : project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings &&
                                  project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings?.font
                                ? project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings?.font
                                : 'Roboto',
                            ) && (
                              <img
                                src={italicIcon}
                                alt="italic"
                                className={styles.stylingFontIcons}
                                style={{
                                  width: '20px',
                                  height: '20px',
                                  backgroundColor: isItalic ? '#e0e0e0' : 'transparent',
                                }}
                                onClick={handleToggleItalic}
                              />
                            )}
                          </div>
                          <div className={styles.alignmentStyling}>
                            <img
                              src={alignLeftIcon}
                              alt="align-left"
                              className={styles.stylingFontIcons}
                              onClick={() => {
                                setTextAlignment('left');
                              }}
                            />
                            <img
                              src={alignCenterIcon}
                              alt="align-center"
                              className={styles.stylingFontIcons}
                              onClick={() => {
                                setTextAlignment('center');
                              }}
                            />
                            <img
                              src={alignRightIcon}
                              alt="align-right"
                              className={styles.stylingFontIcons}
                              onClick={() => {
                                setTextAlignment('right');
                              }}
                            />
                          </div>
                        </div>
                      </ListItem>
                    </List>
                  </Box> */}
                  {/* Logo */}
                  <Box className={styles.resizingDropDown} onClick={handleClickPaidFeature}>
                    <ListItem sx={{ justifyContent: 'space-between' }}>
                      <div>
                        <p className={styles.projectsFunctionHeading}>
                          <strong>Add Logo?</strong>
                        </p>
                      </div>
                      <Checkbox
                        defaultChecked={Boolean(addLogo)}
                        checked={Boolean(addLogo)}
                        color="default"
                        onChange={handleAddLogo}
                        data-voice-action="add-logo"
                      />
                    </ListItem>
                    {addLogo && (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          padding: '10px',
                        }}
                      >
                        <h3 className={styles.projectsFunctionHeading}>Logo:</h3>
                        <div>
                          <div
                            className={
                              selectedImage.size !== 0
                                ? styles.uploadLogoIcon
                                : styles.uploadLogoIcon
                            }
                          >
                            <div>
                              {/* Hidden input for file upload */}
                              <input
                                type="file"
                                name="myImage"
                                accept=".png, .jpg, .jpeg"
                                id="fileInput"
                                style={{ display: 'none' }}
                                onChange={(event) => {
                                  if (
                                    event &&
                                    event.target &&
                                    event.target.files &&
                                    event.target.files[0]
                                  ) {
                                    setSelectedImage(event.target.files[0]);
                                    uploadImage(event.target.files[0], 'logo');
                                  }
                                }}
                              />

                              {/* Custom-styled text or button to trigger file input */}
                              <label
                                htmlFor="fileInput"
                                style={{
                                  cursor: 'pointer',
                                  padding: '10px',
                                  border: '0px solid #ccc',
                                  borderRadius: '4px',
                                }}
                                data-voice-action="upload-logo"
                              >
                                <div className={styles.uploadLogoIconMain}>
                                  <img
                                    src={
                                      selectedImage.size !== 0
                                        ? URL.createObjectURL(selectedImage)
                                        : project.edits.find(
                                            (edit) => edit.id === videoId,
                                            //@ts-ignore
                                          )?.overlaySettings?.logoPath
                                        ? project.edits.find(
                                            (edit) => edit.id === videoId,
                                            //@ts-ignore
                                          )?.overlaySettings?.logoPath
                                        : uploadIcon
                                    }
                                    alt="upload"
                                    // width={'100%'}
                                    // height={'120%'}
                                    className={styles.uploadLogoIcon}
                                  />
                                </div>
                                <p>
                                  {selectedImage.size !== 0 ||
                                  project.edits.find(
                                    (edit) => edit.id === videoId,
                                    //@ts-ignore
                                  )?.overlaySettings?.logo ? null : (
                                    <strong>Upload Logo</strong>
                                  )}
                                </p>
                              </label>
                            </div>
                            {/* )} */}
                          </div>
                          <FormControl sx={{ paddingTop: '10px' }}>
                            <Select
                              value={logoPosition}
                              onChange={handleLogoPosition}
                              sx={{ height: '40px', borderRadius: '8px' }}
                              data-voice-action="logo-position"
                            >
                              {/*choices=['top-left', 'top-right', 'bottom-left', 'bottom-right'],*/}
                              <MenuItem value={'top-right'} data-voice-logo-position="top-right">
                                Top Right
                              </MenuItem>
                              <MenuItem value={'top-left'} data-voice-logo-position="top-left">
                                Top Left
                              </MenuItem>
                              <MenuItem
                                value={'bottom-left'}
                                data-voice-logo-position="bottom-left"
                              >
                                Bottom Left
                              </MenuItem>
                              <MenuItem
                                value={'bottom-right'}
                                data-voice-logo-position="bottom-right"
                              >
                                Bottom Right
                              </MenuItem>
                            </Select>
                          </FormControl>
                        </div>
                      </div>
                    )}
                    <ListItem sx={{ justifyContent: 'space-between' }}>
                      <div>
                        <p className={styles.projectsFunctionHeading}>
                          <strong>Add Intro?</strong>
                        </p>
                      </div>
                      <Checkbox
                        defaultChecked={Boolean(addIntro)}
                        checked={Boolean(addIntro)}
                        color="default"
                        onChange={handleAddIntro}
                        data-voice-action="add-intro"
                      />
                    </ListItem>
                    {addIntro && (
                      <div
                        // className={styles.brandKitItemRight}
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          padding: '10px',
                        }}
                      >
                        <h3 className={styles.projectsFunctionHeading}>Intro:</h3>
                        {/* <div>
                          <input
                            type="file"
                            name="myImage"
                            accept=".png, .mp4"
                            id="fileInputIntro"
                            style={{ display: 'none' }}
                            onChange={(event) => {
                              if (event.target.files) {
                                uploadImage(event.target.files[0], 'intro');
                              }
                            }}
                          />
                          <label
                            htmlFor="fileInputIntro"
                            style={{
                              cursor: 'pointer',
                              padding: '10px',
                              border: '0px solid #ccc',
                              borderRadius: '4px',
                            }}
                          >
                            <div style={{ width: '120px', height: '50px' }}>
                              <BrandKitVideoItem
                                path={
                                  project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings?.intro ?? ''
                                }
                                controls
                              />
                            </div>
                          </label>
                        </div> */}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          {project.edits.find((edit) => edit.id === videoId)?.overlaySettings
                            ?.introPath && (
                            <BrandKitVideoItem
                              path={
                                project.edits.find((edit) => edit.id === videoId)?.overlaySettings
                                  ?.introPath ?? ''
                              }
                              controls
                              style={{ height: '126px', width: '224px' }}
                            />
                          )}

                          <div
                            data-testid={'file'}
                            style={{ marginLeft: '1rem', height: '126px', width: '224px' }}
                            data-voice-action="upload-intro"
                          >
                            <FileUpload
                              styleEl="panel"
                              fileTypes={['.png', '.mp4']}
                              onChange={(file: File) => uploadImage(file, 'intro')}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                    <ListItem sx={{ justifyContent: 'space-between' }}>
                      <div>
                        <p className={styles.projectsFunctionHeading}>
                          <strong>Add Outro?</strong>
                        </p>
                      </div>
                      <Checkbox
                        defaultChecked={Boolean(addOutro)}
                        checked={Boolean(addOutro)}
                        color="default"
                        onChange={handleAddOutro}
                        data-voice-action="add-outro"
                      />
                    </ListItem>
                    {addOutro && (
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          padding: '10px',
                        }}
                      >
                        <h3 className={styles.projectsFunctionHeading}>Outro:</h3>
                        {/* <>
                          <input
                            type="file"
                            name="myImage"
                            accept=".png, .mp4"
                            id="fileInputIntro"
                            style={{ display: 'none' }}
                            onChange={(event) => {
                              if (event.target.files) {
                                uploadImage(event.target.files[0], 'outro');
                              }
                            }}
                          />
                          <label
                            htmlFor="fileInputOutro"
                            style={{
                              cursor: 'pointer',
                              padding: '10px',
                              border: '0px solid #ccc',
                              borderRadius: '4px',
                            }}
                          >
                            <div style={{ width: '150px', height: '100px' }}>
                              <BrandKitVideoItem
                                path={
                                  project.edits.find(
                                    (edit) => edit.id === videoId,
                                  )?.overlaySettings?.outro ?? ''
                                }
                                controls
                              />
                            </div>
                          </label>
                        </> */}
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                          }}
                        >
                          {project.edits.find((edit) => edit.id === videoId)?.overlaySettings
                            ?.outroPath && (
                            <BrandKitVideoItem
                              path={
                                project.edits.find((edit) => edit.id === videoId)?.overlaySettings
                                  ?.outroPath ?? ''
                              }
                              controls
                              style={{ height: '126px', width: '224px' }}
                            />
                          )}
                          <div
                            data-testid={'file'}
                            style={{ marginLeft: '1rem', height: '126px', width: '224px' }}
                            data-voice-action="upload-outro"
                          >
                            <FileUpload
                              styleEl="panel"
                              fileTypes={['.png', '.mp4']}
                              onChange={(file: File) => uploadImage(file, 'outro')}
                            />
                          </div>
                        </div>
                      </div>
                    )}
                  </Box>
                </Grid>
                <Grid xs={12} sm={12} md={6} lg={6} xl={6}>
                  <div className={styles.videoWrapper}>
                    <Grid container>
                      <Grid xs={12} sm={12} md={12} lg={12} xl={12}>
                        <VideoProvider video={video}>{videoComponent}</VideoProvider>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
              </Grid>
              {/* Overlay history display */}
              {currentEdit?.overlayHistory && currentEdit.overlayHistory.length > 0 && (
                <Box sx={{ mb: 2, p: 2, bgcolor: '#f9f9f9', borderRadius: 1 }}>
                  <h4 style={{ margin: '0 0 12px 0' }}>Overlay History</h4>
                  <List dense>
                    {currentEdit.overlayHistory
                      .slice()
                      .reverse()
                      .map((overlay, index) => (
                        <ListItem
                          key={overlay.timestamp}
                          sx={{
                            bgcolor: 'white',
                            mb: 1,
                            borderRadius: 1,
                            border: '1px solid #e0e0e0',
                          }}
                          secondaryAction={
                            <>
                              <Button
                                size="small"
                                startIcon={<ShareIcon />}
                                onClick={() => shareOverlay(overlay.overlayPath, overlay.timestamp)}
                                sx={{ mr: 1 }}
                              >
                                {copiedOverlayTimestamp === overlay.timestamp ? 'Copied!' : 'Share'}
                              </Button>
                              <DownloadButton
                                url={overlay.overlayPath}
                                fileName={getOverlayFileName(overlay)}
                                size="small"
                                sx={{ ml: 1 }}
                              />
                            </>
                          }
                        >
                          <ListItemText
                            primary={`${index === 0 ? '(Latest) ' : ''}${
                              overlay.format.charAt(0).toUpperCase() + overlay.format.slice(1)
                            }`}
                            secondary={new Date(overlay.timestamp).toLocaleString()}
                          />
                        </ListItem>
                      ))}
                  </List>
                </Box>
              )}
            </Box>
          </div>
        </ProjectProvider>
      )}
    </>
  );
};

export default ProjectVideo;
